import { ShipStatus } from '@/tools/constant'
import { createDefaultNeedShipWay } from '@/tools/shipFee'
import needApi from '../apis/need'

const state = {
  needList: {
    maxNeedId: '',
    currentPage: 0,
    nextPageUrl: 'http://',
    data: [],
    mode: 'row' // or 'col'
  },
  needListTaipei: {
    curIdx: 1,
    currentPage: 0,
    nextPageUrl: 'http://',
    data: []
  },
  currentNeed: {
    need_images: []
  },
  currentNeedEdited: false,
  donateNeed: {
    pics: [[]]
  },
  newNeed: {
    imgList: [],
    title: '',
    desc: '',
    date: '',
    commonwealPurchase: false,
    need_section_id: '',
    newNeedList: [{
      name: '',
      number: 1,
      category_id: '',
      category_label: [], // 用于存放popuppicker显示label
      item_category_id: '',
      isAllNew: '',
      nameLength: 0
    }],
    shipWay: createDefaultNeedShipWay()
  },
  receiveNeedInfo: {
    needItems: [],
    id: null, // need_donate_id
    shipfee: 0,
    shipopts: '',
    shipway: ''
  },
  confirmShipInfo: {
    id: null,
    shipway: '',
    shipfee: '',
    shipopts: '',
    giverName: '',
    giverPhone: '',
    giverCity: '',
    giverDistrict: '',
    giverAddress: '',
    needItems: []
  },
  commonwealPurchaseList: {
    loading: false,
    data: [],
    currentPage: 0,
    lastPage: 1,
    total: 0
  },
  availableNeedSections: [],
  needSections: {
    type: '',
    loading: false,
    data: [],
    currentPage: 0,
    lastPage: 1,
    total: 0
  },
  needSectionDetail: {
    id: '',
    type: '',
    name: '',
    matched_count: 0,
    left_count: 0
  },
  needSectionPool: {
    mode: 'row',
    needSectionId: '',
    maxNeedId: '',
    loading: false,
    data: [],
    currentPage: 0,
    lastPage: 1,
    total: 0
  },
  needSectionItemCount: 0
}

const actions = {
  getNeedList ({commit, state}, {page = '', onPool = '', userRoleType = '', isTraceUser = '', status = '', directPurchase = '',
    sort = '', category = '', isSearch = '', bureauId = '', cb = null, isClear = false, noRequestList = false,
    maxNeedId = '', shipway = '', needSectionId = '', needSectionType = ''} = {}) {
    needApi.getNeedList({
      page,
      onPool,
      userRoleType,
      isTraceUser,
      sort,
      status,
      directPurchase,
      category,
      bureauId,
      noRequestList,
      maxNeedId,
      shipway,
      needSectionId,
      needSectionType,
      cb: (data) => {
        if (isClear && bureauId) {
          commit('resetNeedListTaipei')
        } else if (isClear) {
          commit('resetNeedList')
        }

        if (data && !data.error) {
          if (bureauId) {
            commit('setNeedListTaipei', {data})
          } else {
            commit('setNeedList', {isSearch, data})
          }
        }
        if (cb) {
          cb(data)
        }
      }
    })
  },
  getCommonwealPurchaseNeedList ({ commit }, { page = 1, directPurchase = 1 }) {
    commit('setCommonwealPurchaseNeedListLoading', true)
    return needApi.getNeedList({page, onPool: 1, directPurchase, noRequestList: 1})
      .then((data) => {
        commit('setCommonwealPurchaseNeedList', { data })
      })
  },
  getNeedInfo ({commit, state}, {id, cb = null} = {}) {
    needApi.getNeedInfo(
      id,
      (data) => {
        if (data && !data.error) {
          if (data.need_donates && data.need_donates.length) {
            data.need_donates.sort((a, b) => {
              if (a.id > b.id) {
                return -1
              } else if (a.id === b.id) {
                return 0
              } else {
                return 1
              }
            })

            data.need_items.forEach((item) => {
              item.donate_sum = data.need_donates && data.need_donates.length
                ? data.need_donates.reduce((total, cur) => {
                  if (cur.need_item_id === item.id &&
                    cur.status !== ShipStatus.SHIP_STATUS_PASS &&
                    cur.status !== ShipStatus.SHIP_STATUS_CANCEL) {
                    return total + cur.quantity
                  }
                  return total
                }, 0) : 0
            })
          }
          commit('setCurrentNeed', {data})
        }
        if (cb) {
          cb(data)
        }
      }
    )
  },
  getNeedDonateList ({ commit }, { needId, page, perPage }) {
    return needApi.getNeedDonateList(needId, page, perPage)
  },
  getNeedDonateInfo ({commit}, {id}) {
    return needApi.getNeedDonateInfo(id)
  },
  submitNewNeed ({commit}, {data, cb}) {
    needApi.submitNewNeed(data, (data) => cb(data))
  },
  editNeed ({commit, state}, {data, id}) {
    return needApi.editNeed(data, id)
      .then(res => {
        data.need_items = data.need_items.map(item => ({
          ...item,
          left: item.quantity - item.min
        }))
        commit('setCurrentNeed', {
          data: {
            ...data,
            ...res
          }
        })
        commit('setCurrentNeedEdited', {edited: true})
        return res
      })
  },
  getAvailableNeedSections ({ commit }) {
    return needApi.getAvailableNeedSections()
      .then((res) => {
        commit('setAvailableNeedSections', { data: res.data })
        return res.data
      })
  },
  getNeedSections ({ commit }, { page = 1, type = '' }) {
    commit('setNeedSectionsLoading', true)
    return needApi.getNeedSections(page, 20, type)
      .then((res) => {
        commit('setNeedSections', { data: res.data, type })
        commit('setNeedSectionsLoading', false)
        return res.data
      })
      .catch(() => {
        commit('setNeedSectionsLoading', false)
      })
  },
  getNeedSectionPool ({ commit }, { needSectionId, page = 1 }) {
    commit('setNeedSectionPoolLoading', true)
    return needApi.getNeedList({page, onPool: 1, noRequestList: 1, needSectionId})
      .then((data) => {
        commit('setNeedSectionPool', { data, needSectionId })
        commit('setNeedSectionPoolLoading', false)
        return data
      })
      .catch((err) => {
        commit('setNeedSectionPoolLoading', false)
        throw err
      })
  },
  getNeedSectionDetail ({ commit }, { needSectionId }) {
    return needApi.getNeedSectionDetail(needSectionId)
      .then((res) => {
        commit('setNeedSectionDetail', { data: res.data })
        return res.data
      })
  },
  getNeedSectionItemCount ({ commit }, { type = '', name = '' }) {
    return needApi.getNeedSectionItemCount(type, name)
      .then((res) => {
        commit('setNeedSectionItemCount', { data: res.data })
        return res.data
      })
  }
}

const mutations = {
  setNeedList (state, {isSearch, data}) {
    if (isSearch && data.current_page === 1) {
      state.needList.data = []
    }

    if (data.current_page === 1) {
      state.needList.maxNeedId = data.maxNeedId
    }
    state.needList = {
      ...state.needList,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...state.needList.data,
        ...data.data
      ]
    }
  },
  resetNeedList (state) {
    state.needList = {
      mode: state.needList.mode,
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
  },
  setNeedListTaipei (state, {data}) {
    state.needListTaipei = {
      ...state.needListTaipei,
      currentPage: data.current_page,
      nextPageUrl: data.next_page_url,
      data: [
        ...state.needListTaipei.data,
        ...data.data
      ]
    }
  },
  resetNeedListTaipei (state) {
    state.needListTaipei = {
      curIdx: 1,
      currentPage: 0,
      nextPageUrl: 'http://',
      data: []
    }
  },
  setCommonwealPurchaseNeedList (state, { data }) {
    state.commonwealPurchaseList = {
      loading: false,
      data: data.current_page === 1 ? data.data : [...state.commonwealPurchaseList.data, ...data.data],
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total
    }
  },
  setCommonwealPurchaseNeedListLoading (state, loading) {
    state.commonwealPurchaseList = {
      ...state.commonwealPurchaseList,
      loading
    }
  },
  setCurrentNeed (state, {data}) {
    if (data.error) {
      return console.log('需求不存在')
    }
    state.currentNeed = {
      ...state.currentNeed,
      ...data
    }
  },
  setCurrentNeedEdited (state, {edited}) {
    state.currentNeedEdited = edited
  },
  setDonateNeedPics (state, {data, index}) {
    if (state.donateNeed.pics[index]) {
      state.donateNeed.pics[index] = [
        ...state.donateNeed.pics[index],
        ...data
      ]
    } else {
      state.donateNeed.pics[index] = data
    }
  },
  deleteDonateNeedPic (state, {i, itemIndex}) {
    state.donateNeed.pics[i] = state.donateNeed.pics[i].filter((item, index) => itemIndex !== index)
    state.donateNeed.pics = [
      ...state.donateNeed.pics
    ]
  },
  resetDonateNeedPic (state) {
    state.donateNeed.pics = [[]]
  },
  setNewNeed (state, payload) {
    state.newNeed = {
      ...state.newNeed,
      ...payload
    }
  },
  addNewNeedItem (state) {
    state.newNeed.newNeedList = [
      ...state.newNeed.newNeedList,
      {
        name: '',
        number: 1,
        category_label: [],
        category_id: '',
        item_category_id: '',
        isAllNew: state.newNeed.commonwealPurchase ? 1 : '',
        nameLength: 0
      }
    ]
  },
  setNewNeedItem (state, {index, needItem}) {
    let newNeedList = Object.assign([], state.newNeed.newNeedList)
    newNeedList[index] = {
      ...state.newNeed.newNeedList[index],
      ...needItem
    }
    state.newNeed.newNeedList = newNeedList
  },
  resetNewNeed (state) {
    state.newNeed = {
      imgList: [],
      title: '',
      desc: '',
      date: '',
      newNeedList: [{
        name: '',
        number: 1,
        category_label: [], // 用于存放popuppicker显示label
        category_id: '',
        item_category_id: '',
        isAllNew: '',
        nameLength: 0
      }],
      shipWay: createDefaultNeedShipWay()
    }
  },
  changeCurrentNeedsMode (state, { mode }) {
    state.needList.mode = mode
  },
  setReceiveNeedInfo (state, payload) {
    state.receiveNeedInfo = {
      ...state.receiveNeedInfo,
      ...payload
    }
  },
  setNeedDonateConfirmShipInfo (state, payload) {
    state.confirmShipInfo = {
      ...payload
    }
  },
  setAvailableNeedSections (state, { data }) {
    state.availableNeedSections = data
  },
  setNeedSections (state, { data, type }) {
    state.needSections = {
      ...state.needSections,
      type,
      data: data.current_page === 1 ? data.data : [...state.needSections.data, ...data.data],
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total,
      loading: false
    }
  },
  setNeedSectionsLoading (state, loading) {
    state.needSections = {
      ...state.needSections,
      loading
    }
  },
  setNeedSectionPool (state, { data, needSectionId }) {
    state.needSectionPool = {
      ...state.needSectionPool,
      needSectionId,
      data: data.current_page === 1 ? data.data : [...state.needSectionPool.data, ...data.data],
      currentPage: data.current_page,
      lastPage: data.last_page,
      total: data.total
    }

    if (data.current_page === 1) {
      state.needSectionPool.maxNeedId = data.maxNeedId
    }
  },
  setNeedSectionPoolLoading (state, loading) {
    state.needSectionPool = {
      ...state.needSectionPool,
      loading
    }
  },
  resetNeedSectionPool (state) {
    state.needSectionPool = {
      ...state.needSectionPool,
      needSectionId: '',
      maxNeedId: '',
      loading: false,
      data: [],
      currentPage: 0,
      lastPage: 1,
      total: 0
    }
  },
  setNeedSectionDetail (state, { data }) {
    state.needSectionDetail = data
  },
  resetNeedSectionDetail (state) {
    state.needSectionDetail = {
      id: '',
      type: '',
      name: '',
      matched_count: 0,
      left_count: 0
    }
  },
  setNeedSectionItemCount (state, { data }) {
    state.needSectionItemCount = data
  }
}

export default{
  state,
  actions,
  mutations
}
